module.exports = __webpack_public_path__ + "img/icon-fav-circle.57a68daa.svg";